import { CreateReportRequest } from './Report.api.type';

export const reportInitializer = {
  INITIAL_CREATE_REPORT_PARAM: {
    reportReason: '',
    details: '',
    questionId: '',
  } as CreateReportRequest,
};
